import type { QueryClient } from '@tanstack/react-query'
import { flowQueryKeys } from 'v2/shared/utils/query-key-management'
import { type FlowData, FlowNodeTypes } from '../types'

// V2.9 is a real node type: it saves and loads as `ai_agent_v29`, and
// agent-runner switches on that type. Everything else — sidebar, defaults,
// output states, schema, nodevars, channels — is shared with ai_agent_v2.
export const AI_AGENT_V29_LABEL = 'AI Conversation V2.9'
// Node names prefix {{Node.var}} references, so a default name cannot contain a dot.
export const AI_AGENT_V29_DEFAULT_NAME = 'Smart AI Conversation'

// The two builder types are the same node everywhere except the palette entry
// and the Variables tab.
export const isAiAgentV2Type = (type?: string | null): boolean =>
  type === FlowNodeTypes.ai_agent_v2 || type === FlowNodeTypes.ai_agent_v29

// The v2.10 stamp is flow-level, and any loaded version of the flow detail carries it.
export const isV210Flow = (queryClient: QueryClient, flowId = ''): boolean =>
  queryClient
    .getQueriesData<FlowData>({ queryKey: flowQueryKeys().flowData(flowId).slice(0, 2) })
    .some(([, flow]) => flow?.phlo?.attributes?.agent_engine_version === 'v2.10')
